
import AccountSummaryPage from "components/pages/AccountSummaryPage";
export default function CaptureFastBalancesAccountSummary(props) {
    return <AccountSummaryPage/>;
}